import { make } from 'vuex-pathify'
import BookingFlowService from '../../services/booking-flow/service';

const state = {
  products: {
    airportlounge: [],
    addon: []
  }
};

const actions = {
  ...make.actions(state),
  async getUpgrades({ dispatch }, params) {
    await BookingFlowService.results({...this.state.quote, ...params}, "silent").then(response => {
      dispatch('setProducts', response.data['products']);
    });
  }
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};